import React, { useRef, useState } from "react";
import { Dialog, DialogBody, DialogTitle } from "../design/dialog";
import { liteClient as algoliasearch } from "algoliasearch/lite";
import { InstantSearch, useSearchBox, useHits } from "react-instantsearch";
import { Input } from "../design/input";

const searchClient = algoliasearch(
  "2TPD55IBMT",
  "54dbc2a1f35c62cc4384b83a1db66fbf",
);

const Hits = (props) => {
  const { hits } = useHits();

  if (hits.length === 0) {
    return (
      <div className="py-8 text-center">
        <p className="text-sm text-gallery-500">No artists found</p>
      </div>
    );
  }

  return (
    <div className="max-h-80 overflow-y-auto">
      {hits.map((hit) => (
        <button
          key={hit.objectID}
          type="button"
          onClick={() => props.onSelectArtist(hit)}
          className="w-full flex items-center gap-3 px-4 py-3 text-left hover:bg-gallery-50 transition-colors border-b border-gallery-100 last:border-b-0"
        >
          {hit.small_image_url ? (
            <img
              src={hit.small_image_url}
              alt={hit.name}
              className="w-10 h-10 rounded-full object-cover bg-gallery-100"
            />
          ) : (
            <div className="w-10 h-10 rounded-full bg-gallery-200 flex items-center justify-center text-sm font-medium text-gallery-600">
              {hit.name
                .split(" ")
                .map((n) => n[0])
                .join("")
                .slice(0, 2)}
            </div>
          )}
          <div className="flex-1 min-w-0">
            <p className="font-medium text-gallery-900 truncate">{hit.name}</p>
            {hit.nationality && (
              <p className="text-xs text-gallery-500 truncate">{hit.nationality}</p>
            )}
          </div>
          <svg className="w-4 h-4 text-gallery-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      ))}
    </div>
  );
};

const SearchBox = (props) => {
  const { refine } = useSearchBox(props);
  const [inputValue, setInputValue] = useState("");
  const inputRef = useRef(null);

  function setQuery(newQuery) {
    setInputValue(newQuery);
    refine(newQuery);
  }

  return (
    <div className="relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <svg className="w-4 h-4 text-gallery-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <Input
        ref={inputRef}
        value={inputValue}
        placeholder="Search by artist name..."
        className="w-full pl-9"
        onChange={(event) => {
          setQuery(event.currentTarget.value);
        }}
        autoFocus
      />
    </div>
  );
};

const SelectArtist = ({ artist, onSelectArtist }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedArtist, setSelectedArtist] = useState(artist);

  const handleSelectArtist = (artist) => {
    setSelectedArtist(artist);
    onSelectArtist(artist);
    setIsOpen(false);
  };

  return (
    <>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="w-full flex items-center gap-3 px-3 py-2.5 bg-white border border-gallery-300 rounded-sm text-left hover:border-gallery-400 focus:outline-none focus:ring-2 focus:ring-gallery-400 focus:ring-offset-1 transition-colors"
      >
        {selectedArtist ? (
          <>
            {selectedArtist.small_image_url ? (
              <img
                src={selectedArtist.small_image_url}
                alt={selectedArtist.name}
                className="w-8 h-8 rounded-full object-cover bg-gallery-100"
              />
            ) : (
              <div className="w-8 h-8 rounded-full bg-gallery-200 flex items-center justify-center text-xs font-medium text-gallery-600">
                {selectedArtist.name
                  .split(" ")
                  .map((n) => n[0])
                  .join("")
                  .slice(0, 2)}
              </div>
            )}
            <span className="flex-1 font-medium text-gallery-900 truncate">
              {selectedArtist.name}
            </span>
          </>
        ) : (
          <>
            <div className="w-8 h-8 rounded-full bg-gallery-100 flex items-center justify-center">
              <svg className="w-4 h-4 text-gallery-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <span className="flex-1 text-gallery-500">
              Search for an artist...
            </span>
          </>
        )}
        <svg className="w-4 h-4 text-gallery-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 9l4-4 4 4m0 6l-4 4-4-4" />
        </svg>
      </button>

      <Dialog open={isOpen} onClose={setIsOpen}>
        <DialogTitle>Select Artist</DialogTitle>
        <DialogBody>
          <InstantSearch searchClient={searchClient} indexName="artist">
            <div className="mb-4">
              <SearchBox />
            </div>
            <Hits onSelectArtist={handleSelectArtist} />
          </InstantSearch>
        </DialogBody>
      </Dialog>
    </>
  );
};

export default SelectArtist;
